var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { I as ImportantSpriteSchema } from "../../ImportantSprite-329bc41a.js";
import { registerPixiComponent } from "../ComponentRegistry.js";
import { SpriteComponentPixi } from "./Sprite.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../enums-86f58524.js";
import "../../global-33d5eebf.js";
import "../../Sprite-7d2a5fa7.js";
import "../types.js";
import "../../utils/byteArray.js";
import "../../utils/vector.js";
import "../../loader/SpriteLoader.js";
import "../../loader/ImageLoader.js";
import "pixi.js";
import "../../loader/PixiSpriteLoader.js";
import "../../Attach-abbbd93e.js";
import "../../Locomotion-379972de.js";
import "../../Radius-89a665f8.js";
import "../../Transform-9450b7b5.js";
class ImportantSpriteComponentPixi extends SpriteComponentPixi {
  constructor() {
    super(...arguments);
    __publicField(this, "schema", ImportantSpriteSchema);
  }
  transform(pixiData, entity, data, gameModel, viewport) {
    super.transform(pixiData, entity, data, gameModel, viewport);
    const { container } = pixiData;
    const verticalDistanceFromCenter = Math.abs(pixiData.container.y - viewport.center.y) + pixiData.container.height / 2;
    const horizontalDistanceFromCenter = Math.abs(pixiData.container.x - viewport.center.x) + pixiData.container.width / 2;
    let offHorizontally = horizontalDistanceFromCenter - pixiData.container.width > 1920;
    let offVertically = verticalDistanceFromCenter - pixiData.container.height > 1080;
    if (offHorizontally || offVertically) {
      if (!offHorizontally && horizontalDistanceFromCenter > 1920) {
        offHorizontally = true;
      }
      if (!offVertically && verticalDistanceFromCenter > 1080) {
        offVertically = true;
      }
      if (offVertically) {
        if (container.y + pixiData.container.height / 2 > viewport.center.y) {
          container.y = viewport.center.y + 1080 - pixiData.container.height / 2 - data.padding;
        } else {
          container.y = viewport.center.y - 1080 + pixiData.container.height / 2 + data.padding;
        }
      }
      if (offHorizontally) {
        if (container.x > viewport.center.x) {
          container.x = viewport.center.x + 1920 - pixiData.container.width / 2 - data.padding;
        } else {
          container.x = viewport.center.x - 1920 + pixiData.container.width / 2 + data.padding;
        }
      }
      container.visible = true;
    } else if (data.hideInView) {
      container.visible = false;
    }
  }
}
registerPixiComponent("ImportantSprite", ImportantSpriteComponentPixi);
export {
  ImportantSpriteComponentPixi
};
//# sourceMappingURL=ImportantSprite.js.map
